import api from "@/api";

class BaoCaoService {
  // --- PHẦN 1: QUẢN LÝ DANH MỤC (Dành cho Admin) ---
  getAllDanhMucAdmin() {
    return api.get("/api/bao-cao-noi-bo/quan-ly-danh-muc-bao-cao");
  }

  createDanhMuc(data) {
    return api.post("/api/bao-cao-noi-bo/quan-ly-danh-muc-bao-cao", data);
  }

  updateDanhMuc(id, data) {
    return api.put(`/api/bao-cao-noi-bo/quan-ly-danh-muc-bao-cao/${id}`, data);
  }

  deleteDanhMuc(id) {
    return api.delete(`/api/bao-cao-noi-bo/quan-ly-danh-muc-bao-cao/${id}`);
  }

  // --- PHẦN 2: NGHIỆP VỤ BÁO CÁO (Dành cho User & Sếp) ---
  
  // Lấy danh mục để hiển thị Dropdown (Chỉ lấy cái đang kích hoạt)
  getDanhMucActive() {
    return api.get("/api/bao-cao-noi-bo/danh-muc");
  }

  // Gửi báo cáo mới
  createBaoCao(data) {
    return api.post("/api/bao-cao-noi-bo", data);
  }

  // Lấy lịch sử báo cáo của tôi
  getMyReports(params) {
    return api.get("/api/bao-cao-noi-bo/cua-toi", { params });
  }

  // Lấy danh sách báo cáo cho quản lý (Sếp)
  getManagerReports(params) {
    return api.get("/api/bao-cao-noi-bo/quan-ly", { params });
  }

  updateStatus(id, trangThai, ghiChu) {
    // Gọi API PUT: /api/v1/bao-cao-noi-bo/{id}/trang-thai?trangThai=...
    return api.put(`/api/bao-cao-noi-bo/${id}/trang-thai`, null, {
      params: { trangThai, ghiChu }
    });
  }

  revokeReport(id) {
    return api.delete(`/api/bao-cao-noi-bo/${id}/thu-hoi`);
  }

  getStatistics(params) {
    return api.get("/api/bao-cao-noi-bo/thong-ke", { params });
  }
}

export default new BaoCaoService();